import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'

export const DashboardViewContainer = styled.div`
  height: 100vh;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 48px 1fr;
  overflow: auto;
  background: ${({ mode }: { mode: Theme }) => sys[mode].elevation[0].background};
`

export const DashboardViewBody = styled.div`
  padding: 24px 32px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 52px 1fr;
  overflow: auto;
  background: ${({ mode }: { mode: Theme }) => sys[mode].elevation[0].background};
`

export const StyledLoadingContainer = styled.div`
  width: 100%;
  height: 100%;
`

export const StyledNameContainer = styled.div`
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`

export const StyledNameLink = styled.a`
  color: ${({ mode }: { mode: Theme }) => sys[mode].interaction.primary.default};
  text-decoration: none;
  cursor: pointer;
  &:hover {
    color: ${({ mode }: { mode: Theme }) => sys[mode].interaction.primary.hover};
  }
`

export const StyledLabelContainer = styled.span`
  height: 22px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
`

export const StyledEmptyTable = styled.div`
  font-weight: ${sys.fontWeight.regular};
  font-size: ${sys.typescale[14].size};
  line-height: ${sys.typescale[14].lineHeight};
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ mode }: { mode: Theme }) => sys[mode].text.placeholder};
`

export const StyledHeaderContentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`

export const StyledHighlightingCellContainer = styled.div`
  height: 22px;
  white-space: break-spaces;
`

export const StyledHighlightingCell = styled.div``

export const StyledClickableText = styled.span<{
  mode: Theme
}>`
  color: ${({ mode }) => sys[mode].interaction.primary.default};
  cursor: pointer;
  margin: 0 3px;
  text-decoration: underline;
  &:hover {
    color: ${({ mode }) => sys[mode].interaction.primary.hover};
  }
  &:active {
    color: ${({ mode }) => sys[mode].interaction.primary.pressed};
  }
`

export const StyledLearnMoreLink = styled.a.attrs({
  target: '_blank',
  rel: 'noopener noreferrer'
})<{
  mode: Theme
}>`
  margin-left: 3px;
  color: ${({ mode }) => sys[mode].interaction.primary.default};
  cursor: ${({ href }) => (href ? 'pointer' : 'default')};
  &:hover {
    color: ${({ mode }) => sys[mode].interaction.primary.hover};
  }
  &:active {
    color: ${({ mode }) => sys[mode].interaction.primary.pressed};
  }
`
